import { DollarSign, Car, FileText, ClipboardList, AlertOctagon } from 'lucide-react';

const AuditTypeIcon = ({ type, className = "w-4 h-4" }) => {
  const icons = {
    Financial: <DollarSign className={className} />,
    Mileage: <Car className={className} />,
    'NCCI Edits': <FileText className={className} />,
    SMOT: <ClipboardList className={className} />,
    Unresolved: <AlertOctagon className={className} />
  };

  return icons[type] || <FileText className={className} />;
};

export default AuditTypeIcon;
